document.addEventListener('alpine:init', () => {
  Alpine.data('recruitmentSlider', () => ({
    slider: null,

    init() {
      if (document.body.classList.contains('wp-admin')) {
        this.$refs.cardSlider.classList.add('flex', 'gap-8', 'overflow-x-auto');

        for (const child of [...this.$refs.cardSlider.children]) {
          child.classList.add('shrink-0', 'w-auto');
        }
      }

      this.$nextTick(() => {
        this.slider = new Swiper(this.$refs.slider, {
          speed: 400,
          slidesPerView: 'auto',
          centeredSlides: true,
          spaceBetween: 24,
          navigation: {
            nextEl: '.dna-cards__slider-nav-button--next',
            prevEl: '.dna-cards__slider-nav-button--prev',
            disabledClass: 'dna-cards__slider-nav-button--disabled',
          },
          keyboard: {
            enabled: true,
          },
          threshold: 3,
        });

        window.addEventListener('fast-tabs', () => this.slider.update());
      });

      this.$refs.overlay.addEventListener('click', (e) => this.closeClick(e));
    },

    closeClick(e) {
      if (
        e.target.classList.contains('dna-cards__overlay') ||
        e.target.classList.contains('swiper-container') ||
        e.target.classList.contains('swiper-wrapper') ||
        e.target.classList.contains('swiper-slide')
      ) {
        this.hide();
      }
    },

    show(i) {
      this.slider.slideTo(i, 0);
      this.$root.classList.add('dna-cards--overlay-visible');
      this.$refs.overlay.classList.add('dna-cards__overlay--visible');
    },

    hide() {
      this.$root.classList.remove('dna-cards--overlay-visible');
      this.$refs.overlay.classList.remove('dna-cards__overlay--visible');
    },
  }));
});